<div class="containers-fluid-page1" style="overflow: hidden;">
<div class="mat-dialog-container1">
      <div class="containers-fluid page1">
   
          <!-- <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Unauthorized Page</div> -->
   
  
          <div class="profile_details">
              <div class="page1__content shadow p-3" style="min-height: calc(58vh - 255px);">

                  <div class="row" style="padding-top: 125px;">
                      <div class="col-md-6">
                           <img style="width: 78%;margin-left: 66%;margin-top: -62%;" src="/assets/session-expired.PNG">
                      </div>
                      <div class="col-md-6">
                          
                          <p style="font-size: large;margin-left: -224px; margin-top: 25%; color: blue;">
                            <b>Your session has expired, please login again.</b>
                          </p>
                          <button class="add_button_new" style="float: right; top: 10px;width: 58%;height: 31%;right:75%;color: white;"(click)="open()" mat-raised-button color="primary"> Ok </button>&nbsp;
                          <form [formGroup]="formDetail">
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  
    </div>
</div>
<!-- </div> -->

<style>
  .containers-fluid page1{
    overflow: hidden;
    border-radius: 10px;
  }
  .profile_details{
    overflow: hidden;
  }
.page1 {
    color: white;
    padding: 0 0rem;
    padding-top: 0px;
    padding-right: 0rem;
    padding-bottom: 0px;
    padding-left: 0rem;
    background: white;
 
    overflow: hidden;
} 
::ng-deep .mat-dialog-container {
    display: block;
    padding: 24px;
    border-radius: 10px;
    box-sizing: border-box;
    overflow: hidden;
    outline: 0;
    width: 100%;
    height: 100%;
    min-height: inherit;
    max-height: inherit;
}

</style>

